import type { Typed } from 'services/api/fields/core';

import type { ClientOptions } from './Client';

export interface CollaborationOptions {
  id?: string;
  name?: string;
  clientType?: string;
  ownerId?: string;
  ownerName?: string;
  ownerType?: string;
  collaboratorId?: string;
  collaboratorNames?: string;
  collaborators?: ClientOptions[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
}

let Collaboration: new <T extends CollaborationOptions>(options: T) => Typed<_Collaboration<T>, T>;

class _Collaboration<T extends CollaborationOptions = CollaborationOptions> {
  id!: string;
  name!: string;
  clientType!: string;
  collaborators!: ClientOptions[];

  constructor(options: T) {
    Object.assign(this, options);

    this.id = options.id || options.ownerId || '';
    this.name = options.name || options.ownerName || '';
    this.clientType = options.clientType || options.ownerType || '';
    this.collaborators = options.collaborators || [];
  }
}

// eslint-disable-next-line prefer-const
Collaboration = _Collaboration as typeof Collaboration;

export default Collaboration;
export { Collaboration };
export type Collaboration<T extends CollaborationOptions = CollaborationOptions> = _Collaboration<T> &
  Omit<T, keyof _Collaboration<T>>;
